import { Link } from 'react-router-dom'
import { TrendingUp, AlertTriangle } from 'lucide-react'
import { LimitExceededError } from '../../lib/api'

const LIMIT_LABELS: Record<string, string> = {
  uploads: 'upload mensili',
  connectors: 'connettori attivi',
  ai_calls: 'chiamate AI mensili',
}

interface Props {
  error: Error | null
}

/**
 * Banner da mostrare quando una chiamata API restituisce HTTP 402.
 * Mostra il tipo di limite raggiunto, i valori corrente/massimo e il link a /upgrade.
 * Non renderizza nulla se l'errore non è un LimitExceededError.
 */
export function LimitExceededBanner({ error }: Props) {
  if (!(error instanceof LimitExceededError)) return null

  const { limit_type, current, max } = error.detail
  const label = LIMIT_LABELS[limit_type] ?? limit_type
  const maxLabel = max === 0 ? 'illimitato' : max

  return (
    <div
      className="flex items-start gap-3 rounded-xl border px-4 py-3"
      style={{
        background: 'rgba(234,179,8,0.08)',
        borderColor: 'rgba(234,179,8,0.3)',
      }}
    >
      <AlertTriangle
        size={18}
        className="shrink-0 mt-0.5"
        style={{ color: 'var(--km-warning)' }}
      />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold" style={{ color: 'var(--km-warning)' }}>
          Limite {label} raggiunto
        </p>
        <p className="text-xs mt-0.5" style={{ color: 'var(--km-text-muted)' }}>
          Hai usato <strong>{current}</strong> su <strong>{maxLabel}</strong> {label} disponibili questo mese.
          Fai upgrade per continuare senza interruzioni.
        </p>
      </div>
      <Link
        to="/upgrade"
        className="shrink-0 flex items-center gap-1.5 text-xs font-semibold px-3 py-1.5 rounded-lg transition-opacity hover:opacity-80"
        style={{ background: 'var(--km-gradient-brand)', color: '#fff' }}
      >
        <TrendingUp size={13} />
        Upgrade
      </Link>
    </div>
  )
}
